module.exports = __webpack_public_path__ + "static/img/result_4.2bc3a4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ngs_second/transcriptome/sequencing/result_4.png
// module id = EzQe
// module chunks = 16